import Vue from "vue";
import App from "./App.vue";
import router from "./router";

import { library, dom } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { faAED } from "./static/aed";

library.add(faAED, fas, far);
dom.watch();

Vue.config.productionTip = false;

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
